import script from "./PlateCodeDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./PlateCodeDropdown.vue?vue&type=script&setup=true&lang=js"

import "./PlateCodeDropdown.vue?vue&type=style&index=0&id=c877c284&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c877c284"]])

export default __exports__